import { useApiCall } from './useApi';

export function useUserProfile() {
  const { data, loading, error, refetch } = useApiCall('/me/profile');
  return { data, loading, error, refetch };
}
